/**
 * obtain the value of a specific storage
 * @param item is storage key
 */ export var getToken = function(item) {
    if ("object" !== "undefined") {
        return window.sessionStorage.getItem(item);
    }
    return false;
};
